import {
  ILoginBusinessResponse,
  ILoginDataFrontendResponse,
  ILoginServiceResponse,
} from "../../models/interfaces/backendResponses";
import { getBusiness_service } from "../../services/getBusiness";
import { getToken_service } from "../../services/getToken";

export async function validateTheLoginAdapter(
  email,
  password,
  idBusiness = null,
  idLounge = null
) {
  // Set the params for the getTokenService
  let backMessage = "";
  const params = new URLSearchParams();
  params.append("grant_type", "password");
  params.append("client_id", "passwordclient");
  params.append("client_secret", "passwordclient-secret");
  params.append("username", email);
  params.append("password", password);
  params.append("idEmpresa", idBusiness);
  params.append("idLocal", idLounge);

  // Get the token and the business associated
  const results: ILoginServiceResponse = await getToken_service(params);
  if (!results.isSuccess) {
    return results;
  }
  localStorage.setItem("access_token", results.data.access_token);

  const relationEmployee = results?.data?.RelationEmployee
    ? JSON.parse(results.data.RelationEmployee)
    : null;
  // "[{"CompanyId":1353,"CompanyName":"quastictic sac","Locals":[{"LocalName":"quastictic sac","LocalId":1078}]}]"
  const companyList =
    relationEmployee?.map((company) => ({
      businessId: company.CompanyId,
      businessName: company.CompanyName,
      lounges: company.Locals.map((local) => ({
        loungeId: local.LocalId,
        loungeName: local.LocalName,
        isCentral: !!local.isCentral,
      })),
    })) || []; // Si no hay relación, se asigna un array vacío

  // Enriquecer con isCentral desde el endpoint de locales (tbl_vtf_local.vtf_bit_escentral)
  try {
    const token = localStorage.getItem("access_token");
    if (token) {
      const loungesRes = await fetch("/api/v2/locals", { headers: { Authorization: `Bearer ${token}` } });
      const loungesJson = await loungesRes.json();
      const loungesData: any[] = loungesJson?.data || [];
      companyList.forEach((company) => {
        company.lounges.forEach((l) => {
          const match = loungesData.find((ld: any) => Number(ld.lounge) === l.loungeId);
          if (match) l.isCentral = Number(match.isCentral) === 1;
        });
      });
    }
  } catch { /* ignore */ }

  const account_info = {
    employee: {
      id: results.data.IdEmpleado,
      name: results.data.Name,
      lastName: results.data.LastName,
      email: results.data.Email,
      profileImage: results.data.ProfileImage || "",
      alias: results.data.Alias || "",
    },
    lounge: {
      id: idLounge,
      name: "",
    },
    company: {
      id: idBusiness,
      name: "",
    },
    role: {
      id: results.data.IdRole || null,
      name: results.data.Role
        ? results.data.Role.charAt(0).toUpperCase() +
          results.data.Role.slice(1).toLowerCase()
        : "",
    },
    plan: {
      id: results.data.PlanId || null,
      name: results.data.PlanName || "",
    },
  };

  localStorage.setItem("account_info", JSON.stringify(account_info));

  // Guardar warnings del backend (ej: sede sin horarios)
  if (results.data.Warnings && Array.isArray(results.data.Warnings)) {
    localStorage.setItem("login_warnings", JSON.stringify(results.data.Warnings));
  } else {
    localStorage.removeItem("login_warnings");
  }

  const adaptData = {
    idEmployee: null,
    companyList: companyList,
  };

  return {
    isSuccess: true,
    status: 200,
    message: "Iniciado sesion con exito",
    data: adaptData,
  };
}
